import { TTV_CONVERSION_SOUND_IDS_STORAGE_KEY } from "@/app/(application)/(normal)/create/ttvConversionSoundIds/constants";

// Sound ids correlate with their originating transfer across navigation and reload in this tab. Legacy ids remain attributable without inventing a transfer id.
export const readTtvConversionSoundIds = (): Map<string, string | null> => {
  try {
    const stored: unknown = JSON.parse(
      sessionStorage.getItem(TTV_CONVERSION_SOUND_IDS_STORAGE_KEY) ?? "[]"
    );
    if (!Array.isArray(stored)) {
      return new Map();
    }
    return new Map(
      stored.flatMap((entry): [string, string | null][] => {
        if (typeof entry === "string") {
          return [[entry, null]];
        }
        if (
          Array.isArray(entry) &&
          typeof entry[0] === "string" &&
          (entry[1] === null || typeof entry[1] === "string")
        ) {
          return [[entry[0], entry[1]]];
        }
        return [];
      })
    );
  } catch (error) {
    console.error("Could not read the transferred take IDs", error);
    return new Map();
  }
};
